import React from 'react';
import cn from 'classnames';
import useTheme from '@material-ui/core/styles/useTheme';

export type LinkProps = React.HTMLAttributes<HTMLAnchorElement> & {
  className?: string;
  href?: string;
  target?: string;
  disabled?: boolean;
};

export const Link = ({ className, children, target, disabled, ...linkProps }: LinkProps): JSX.Element => {
  const theme = useTheme();
  return (
    <a
      className={`${disabled ? 'opacity-20 cursor-pointer pointer-events-none' : ''} ${cn(className)}`}
      style={{ color: theme.palette.primary.main }}
      {...linkProps}
      target={target ? target : undefined}
    >
      {children}
    </a>
  );
};
